class BuyBottomBar extends HTMLElement {
    loading = false;
    bindProducts = [];
    mainProductId = '';
    currency = '';
    showMore = false;
    isEduProduct = false;
    isLoggedIn = false;
    isEduVerified = false;
    eduPageUrl = '';

    // 缓存的 DOM 引用，避免每次 updatePrice 重复查询
    _priceEl = null;
    _beforeEl = null;
    _mbPriceEl = null;
    _mbBeforeEl = null;
    _discountEls = null;
    _loadingEl = null;
    _paypalEls = null;

    constructor() {
      super();
      this.cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');
      this.careGuide = this.dataset.careGuide;
      this.hasCare = this.dataset.hasCare || false;
      this.currency = this.dataset.currency;
      this.isEduProduct = this.dataset.isEduProduct === 'true';
      this.isLoggedIn = this.dataset.isLoggedIn === 'true';
      this.isEduVerified = this.dataset.isEduVerified === 'true';
      this.eduPageUrl = this.dataset.eduPageUrl;
      this.init();
    }

    connectedCallback() {
      // 组件挂载后缓存内部 DOM 引用（一次性查询）
      this._priceEl = this.querySelector('.price');
      this._beforeEl = this.querySelector('.before');
      this._mbPriceEl = this.querySelector('.mb_price');
      this._mbBeforeEl = this.querySelector('.mb_before');
      this._discountEls = Array.from(this.querySelectorAll('.price-discouter'));
      this._loadingEl = this.querySelector('.buy-loading');
      // PayPal 元素跨整个 document，不属于 this 内部，延迟缓存
    }

    init() {
      this.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (this.isEduProduct && !this.isLoggedIn) {
            const returnTo =
              window.location.pathname +
              window.location.search +
              window.location.hash;
            window.location.href =
              '/account/login?return_to=' + encodeURIComponent(returnTo);
            return;
          }
          if (this.isEduProduct && !this.isEduVerified) {
            const dialog = document.getElementById('edu-header-verify-now-dialog');
            if (dialog) dialog.showModal();
            return;
          }
          if (this.loading) return;
          if (this.careGuide === 'strong' && this.hasCare) {
            this.showCareChooseDialog();
          } else {
            this.handleAddToCart();
          }
        });
      });

      const showMoreBtn = this.querySelector('.show-more-btn');
      if (showMoreBtn) {
        showMoreBtn.addEventListener('click', () => this.toggleShowMoreDesc());
      }
    }

    handleAddToCart() {
      this.getMainProduct();
      this.getBindProduct();
      this.onSubmitHandler();
    }

    showCareChooseDialog() {
      const careDialog = document.querySelector('product-detail-dialog-hovercare-choose');
      if (careDialog) careDialog.showModal();
    }

    async onSubmitHandler() {
      const data = {
        items: [
          { id: this.mainProductId, quantity: 1 },
          ...this.bindProducts,
        ],
        sections: 'cart-drawer,cart-icon-bubble',
      };

      this.toggleLoading();
      try {
        const response = await fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
          },
          body: JSON.stringify(data),
        });
        const result = await response.json();

        if (result.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: this.mainProductId,
            errors: result.errors || result.description,
            message: result.message,
          });
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.mainProductId,
            cartData: result,
          });
        }
        this.error = false;

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => { setTimeout(() => { this.cart.renderContents(result); }); },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(result);
        }
      } catch (_) {
        // network error — silently fail
      } finally {
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        this.toggleLoading();
      }
    }

    getMainProduct() {
      this.mainProductId = document.querySelector('product-selector').currentVariantId;
    }

    getBindProduct() {
      this.bindProducts = [];
      const tags = Array.from(document.querySelectorAll('accessory-product'));
      tags.forEach((item) => {
        if (item.isSelected) {
          this.bindProducts.push({ id: item.currentId, quantity: item.getNumber() });
        }
      });
      dataLayer.push({
        event: 'market/add',
        timestamp: new Date().toISOString(),
        isApp: USER_AGENT.isApp,
        uaMessage: USER_AGENT,
        productList: [...this.bindProducts, { id: this.mainProductId, quantity: 1 }],
      });
      const careTags = Array.from(document.querySelectorAll('care-product'));
      careTags.forEach((item) => {
        if (item.isShow && item.isSelected) {
          this.bindProducts.push({ id: item.currentId, quantity: 1 });
        }
      });

      const careDialog = document.querySelector('product-detail-dialog-hovercare-choose');
      if (careDialog && careDialog.chooseId) {
        this.bindProducts.push({ id: careDialog.chooseId, quantity: 1 });
      }
    }

    toggleLoading() {
      this.loading = !this.loading;
      if (this._loadingEl) this._loadingEl.classList.toggle('tw-hidden');
    }

    // CSS transition 替代 GSAP 旋转 —— 无需加载 GSAP 库
    toggleShowMoreDesc() {
      const tipEl = this.querySelector('.bar-tip');
      const btn = this.querySelector('.show-more-btn');
      this.showMore = !this.showMore;
      if (btn) btn.classList.toggle('rotated', this.showMore);
      if (tipEl) tipEl.classList.toggle('show-more-desc', this.showMore);
    }

    toggleAddToCartButton(available) {
      const buttons = this.querySelectorAll('button');
      const btnTexts = this.querySelectorAll('.buy-bottom-bar-btn-text');
      if (!buttons || buttons.length === 0) return;

      buttons.forEach((button) => {
        if (button.disabled && available === 'true') {
          button.disabled = false;
          btnTexts.forEach((t) => { t.textContent = this.dataset.btnText; });
        } else if (!button.disabled && available === 'false') {
          button.disabled = true;
          btnTexts.forEach((t) => { t.textContent = this.dataset.btnOutOfStockText; });
        }
      });
    }

    updatePrice() {
      if (!window.Decimal) return;

      // ── 批量读阶段（避免 layout thrashing）──
      const main = document
        .querySelector('.product-version-option input:checked')
        ?.closest('.product-version-option');
      if (!main) return;

      const { price: mainPrice, before: mainBefore, available: mainAvailable } = main.dataset;
      this.toggleAddToCartButton(mainAvailable);

      let total_price = new Decimal(this.handlePrice(mainPrice));
      let total_before = new Decimal(this.handlePrice(mainBefore));

      const selectedAccessories = Array.from(
        document.querySelectorAll('accessory-product')
      ).filter((item) => item.isSelected);

      for (const item of selectedAccessories) {
        const count = parseInt(item.getNumber(), 10);
        const priceEl = item.querySelector('.current-price');
        if (!priceEl) continue;
        const { price, before } = priceEl.dataset;
        const currentPrice = new Decimal(this.handlePrice(price));
        const originPrice = new Decimal(this.handlePrice(before));
        total_price = total_price.plus(currentPrice.times(count));
        const actualBefore = currentPrice.greaterThan(originPrice)
          ? currentPrice.times(count)
          : originPrice.times(count);
        total_before = total_before.plus(actualBefore);
      }

      Array.from(document.querySelectorAll('care-product')).forEach((item) => {
        if (!item.isShow || !item.isSelected) return;
        const count = parseInt(item.getNumber(), 10) || 0;
        const priceEl = item.querySelector('.current-price');
        if (!priceEl) return;
        const { price, before } = priceEl.dataset;
        const currentPrice = new Decimal(this.handlePrice(price));
        const originPrice = new Decimal(this.handlePrice(before));
        total_price = total_price.plus(currentPrice.times(count));
        const actualBefore = currentPrice.lessThan(originPrice)
          ? originPrice.times(count)
          : currentPrice.times(count);
        total_before = total_before.plus(actualBefore);
      });

      const priceText = this.currency + total_price.toString();
      const beforeText = this.currency + total_before.toString();
      const showBefore = total_before.greaterThan(total_price);
      const isPercent = this.dataset.discountType === 'percent';
      let discountText = '';
      if (showBefore) {
        const discountPercent = total_before
          .minus(total_price)
          .times(100)
          .dividedBy(total_before)
          .toNumber();
        const percentRound = this.dataset.percentRound || 'floor';
        let roundedDiscountPercent = discountPercent;
        if (percentRound === 'round') {
          roundedDiscountPercent = Math.round(discountPercent);
        } else if (percentRound === 'ceil') {
          roundedDiscountPercent = Math.ceil(discountPercent);
        } else {
          roundedDiscountPercent = Math.floor(discountPercent);
        }
        const discountValue = total_before.minus(total_price);
        discountText = isPercent
          ? '- ' + roundedDiscountPercent + '%'
          : 'Save ' + this.currency + discountValue;
      }

      // ── 批量写阶段（单次 rAF）──
      requestAnimationFrame(() => {
        if (this._priceEl) this._priceEl.textContent = priceText;
        if (this._beforeEl) this._beforeEl.textContent = showBefore ? beforeText : '';
        if (this._mbPriceEl) this._mbPriceEl.textContent = priceText;
        if (this._mbBeforeEl) this._mbBeforeEl.textContent = showBefore ? beforeText : '';

        (this._discountEls || []).forEach((el) => {
          if (showBefore) {
            el.classList.remove('tw-hidden');
            el.textContent = discountText;
          } else {
            el.classList.add('tw-hidden');
          }
        });

        this.updatePayPal(total_price.toString());
      });
    }

    handlePrice(price) {
      return price.toString().replace(/,/g, '') || 0;
    }

    updatePayPal(price) {
      if (!price) return;
      clearTimeout(this._paypalTimer);
      // 延迟缓存（首次调用时查询一次）
      if (!this._paypalEls) {
        this._paypalEls = Array.from(document.querySelectorAll('.product-buy-paypal'));
      }
      this._paypalEls.forEach((el) => { el.dataset.ppAmount = price; });
      this._paypalTimer = setTimeout(() => { this.paypalLoading = false; }, 800);
    }
  }

  customElements.define('buy-bottom-bar', BuyBottomBar);
